"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bonus = void 0;
var vue_1 = require("vue");
var SpaceBonus_1 = require("../SpaceBonus");
exports.Bonus = vue_1.default.component('bonus', {
    props: {
        bonus: {
            type: Array,
        },
    },
    data: function () {
        return {};
    },
    render: function (createElement) {
        var bonuses = [];
        var idx = 0;
        var build_css_class = function (idx, bonus) {
            var ret = 'board-space-bonus board-space-bonus--';
            if (bonus === SpaceBonus_1.SpaceBonus.TITANIUM) {
                ret += 'titanium';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.STEEL) {
                ret += 'steel';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.PLANT) {
                ret += 'plant';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.DRAW_CARD) {
                ret += 'card';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.HEAT) {
                ret += 'heat';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.POWER) {
                ret += 'power';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.OCEAN) {
                ret += 'bonusocean';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.ANIMAL) {
                ret += 'animal';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.MICROBE) {
                ret += 'microbe';
            }
            else if (bonus === SpaceBonus_1.SpaceBonus.TEMPERATURE) {
                ret += 'bonustemperature';
            }
            ret += ' board-space-bonus-pos--' + idx.toString();
            return ret;
        };
        for (var _i = 0, _a = this.bonus; _i < _a.length; _i++) {
            var bonus = _a[_i];
            idx += 1;
            bonuses.push(createElement('i', { 'class': build_css_class(idx, bonus) }));
        }
        return createElement('div', { 'class': 'board-space-bonuses' }, bonuses);
    },
});
//# sourceMappingURL=Bonus.js.map